/**
 * @description : API request methods.
 * @requires {Object} baseClient.
 * @requires {Object} configService.
 */
function trackingService(baseClient, configService) {

  baseClient.setBaseUrl(configService.api.base);

  return {
    /**
     * @description : Gets list of items for specified user.
     * @param {String} userId A user id.
     * @param {String} siteId A site id.
     * @param {Number} limit Number of results to retrieve.
     * @returns {Object}
     */
    getHistory: (userId, siteId, limit = 0) => {

      const request = {
        method: 'GET',
        uri: `/mailpieces/v2/user/${userId}/history/${siteId}`
      };

      if (limit !== 0) {

        request.params = { limit: limit };

      }

      return baseClient.sendRequest(request);

    },
    /**
     * @description : Gets details of item.
     * @param {String} trackingNumber
     * @returns {Object}
     */
    getEvents: (trackingNumber) => {

      const request = {
        method: 'GET',
        uri: `/mailpieces/v2/${trackingNumber.toUpperCase()}/events`,
        isWithCredentialRequired: true,
        isgetRecaptchaHeadersRequired: true
      };

      return baseClient.sendRequest(request);

    },
    /**
     * @description : Gets the signature tied to an item.
     * @param {String} uri - uri of the signature.
     * @param {Object} headers - headers needed for the call.
     * @returns {Object}
     */
    getSignature: (uri, headers) => {

      const request = {
        method: 'GET',
        uri: uri,
        isWithCredentialRequired: true,
        headers: headers,
        responseType: 'blob'
      };

      return baseClient.sendRequest(request);

    },
    /**
     * @description : Gets summary of items.
     * @param {Number} jwtMailPieces Number of results to retrieve.
     * @param {Number} limit Number of results to retrieve.
     * @returns {Object}
     */
    getSummary: (jwtMailPieces) => {

      const request = {
        method: 'GET',
        uri: '/mailpieces/v2/summary',
        params: { mailPieceId: jwtMailPieces }
      };

      return baseClient.sendRequest(request);

    },
    /**
     * @description : Sends a Delete Request to server.
     * @param {Array} mailPieceId singular or multi Tracking Numbers.
     * @param {Number}  userId value of the guid.
     * @param {String} siteId value from Config service.
     * @returns {Object}
     */
    deleteCards: (mailPieceId, userId, siteId) => {

      const request = {
        method: 'DELETE',
        uri: `/mailpieces/v2/user/${userId}/history/${siteId}`,
        params: { mailPieceId: mailPieceId }
      };

      return baseClient.sendRequest(request);

    }

  };

}

export default trackingService;



// WEBPACK FOOTER //
// ./src/angular-services/parcels/tracking.service.js